import { render, staticRenderFns } from "./MonatsabschlussEditPopover.vue?vue&type=template&id=54a88c03&"
import script from "./MonatsabschlussEditPopover.vue?vue&type=script&lang=ts&"
export * from "./MonatsabschlussEditPopover.vue?vue&type=script&lang=ts&"
import style0 from "./MonatsabschlussEditPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports